import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { QuickBriefService } from '../../services/quick-brief.service';

@Component({
  selector: 'qb-outcome-step',
  templateUrl: './outcome-step.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'flex min-h-0 flex-1 flex-col overflow-hidden' },
})
export class QbOutcomeStep {
  readonly brief = inject(QuickBriefService);
}
